module.exports = __webpack_public_path__ + "img/clp.95f3020d.png";